import { Badge } from "@amzn/awsui-components-react";

const EMPTY_STRING = "";

const DISPLAY_VALUES = {
    STANDARD: "Standard",
    NON_STANDARD: "NonStandard",
    NON_STANDARD_SUPPORTED: "NonStandardSupported",
    DASH: "-",
    UNDEFINED: "undefined",
};

type BadgeColorType =
    | "blue"
    | "red"
    | "grey"
    | "green"
    | "severity-critical"
    | "severity-high"
    | "severity-medium"
    | "severity-low"
    | "severity-neutral"
    | undefined;

const BADGE_COLORS = {
    BLUE: "blue" as BadgeColorType,
    RED: "red" as BadgeColorType,
    GREY: "grey" as BadgeColorType,
};

const REQUEST_TYPES = {
    STANDARD: "standard",
    NON_STANDARD: "nonstandard",
    NON_STANDARD_SUPPORTED: "nonstandardsupported",
};

const isEmptyValue = (value: any) => {
    return !value || (typeof value === "string" && value.trim() === EMPTY_STRING);
};

const renderDash = () => {
    return <div>{DISPLAY_VALUES.DASH}</div>;
};

export function buildRequestTypeBadge(values: any) {
    let requestType, itemStatus;

    if (Array.isArray(values)) {
        [requestType, itemStatus] = values;
    } else if (typeof values === "string") {
        // If it's a string (which happens in form utils), split it
        const parts = values.split(" ").filter(Boolean);
        requestType = parts[0];
        itemStatus = parts[1];
    } else {
        // If it's something else unexpected, handle as undefined
        requestType = undefined;
        itemStatus = undefined;
    }

    const rawValue = requestType || itemStatus;

    // If rawValue is undefined, empty string, or just whitespace, return a dash
    if (isEmptyValue(rawValue)) return renderDash();

    // Normalize only if it's a string
    const normalized = typeof rawValue === "string" ? rawValue.toLowerCase().replace(/[-\s]/g, EMPTY_STRING) : "";

    let displayValue = rawValue;
    let badgeColor = BADGE_COLORS.GREY;

    switch (normalized) {
        case REQUEST_TYPES.STANDARD:
            displayValue = DISPLAY_VALUES.STANDARD;
            badgeColor = BADGE_COLORS.BLUE;
            break;
        case REQUEST_TYPES.NON_STANDARD:
            displayValue = DISPLAY_VALUES.NON_STANDARD;
            badgeColor = BADGE_COLORS.RED;
            break;
        case REQUEST_TYPES.NON_STANDARD_SUPPORTED:
            displayValue = DISPLAY_VALUES.NON_STANDARD_SUPPORTED;
            badgeColor = BADGE_COLORS.RED;
            break;
        default:
            // Only use rawValue as displayValue if it's not undefined or empty
            displayValue = rawValue === undefined || rawValue === null ? DISPLAY_VALUES.DASH : rawValue;
            badgeColor = BADGE_COLORS.GREY;
    }

    // If displayValue is undefined or empty, return a dash instead of a badge
    if (isEmptyValue(displayValue) || displayValue === DISPLAY_VALUES.UNDEFINED) return renderDash();

    return <Badge color={badgeColor}>{displayValue}</Badge>;
}
